import TraceParent from 'traceparent';

const newTraceparent = () =>
  TraceParent.startOrResume(undefined, {
    transactionSampleRate: 1,
  }).toString();

export default newTraceparent;
